var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 14.5,
    viewBox: "0 0 14.5 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17578",
    "data-name": "Group 17578",
    transform: "translate(-982 -456.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-info-4021629",
    transform: "translate(982 456.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245526",
    "data-name": "Path 245526",
    d: "M7.25,14.5a7.259,7.259,0,1,1,5.124-2.126A7.251,7.251,0,0,1,7.25,14.5Zm0-13.435a6.193,6.193,0,1,0,4.372,1.814A6.186,6.186,0,0,0,7.25,1.065Z",
    fill: "#038de3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245527",
    "data-name": "Path 245527",
    d: "M551.056,522.94a.643.643,0,0,1,.6.6V527.4a.6.6,0,0,1-.6.6.643.643,0,0,1-.6-.6v-3.858A.6.6,0,0,1,551.056,522.94Z",
    transform: "translate(-543.806 -516.621)",
    fill: "#038de3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245528",
    "data-name": "Path 245528",
    d: "M530.171,287.106a.865.865,0,1,1-.865-.865.865.865,0,0,1,.865.865",
    transform: "translate(-522.057 -282.782)",
    fill: "#038de3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/infoCircle.1c08465344dd1eebb9d1609793747c75.svg";
export { ForwardRef as ReactComponent };